var _line, _path, _path2, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExerciseLibInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1.2,
    x2: 3.14224,
    y2: -1.2,
    transform: "matrix(0.711911 -0.70227 0.711911 0.70227 3.72833 21.5968)",
    stroke: "#C2C3CD",
    strokeWidth: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1625 8.37407C21.9433 9.1554 21.9343 10.413 21.1424 11.1831L19.5558 12.7259L11.1775 4.34159L12.7641 2.79879C13.556 2.02875 14.8309 2.0379 15.6117 2.81923L21.1625 8.37407Z",
    stroke: "#C2C3CD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82598 15.5716C2.0515 14.784 2.07059 13.5265 2.86863 12.7628L4.468 11.2323L12.7778 19.6823L11.1784 21.2129C10.3804 21.9765 9.10559 21.9572 8.3311 21.1696L2.82598 15.5716Z",
    stroke: "#C2C3CD",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.2,
    x2: 9.42672,
    y2: -1.2,
    transform: "matrix(0.711911 -0.70227 0.711911 0.70227 8.948 16.4481)",
    stroke: "#C2C3CD",
    strokeWidth: 2.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1.2,
    x2: 3.14224,
    y2: -1.2,
    transform: "matrix(0.711911 -0.70227 0.711911 0.70227 19.3873 6.15002)",
    stroke: "#C2C3CD",
    strokeWidth: 2.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseLibInactiveIcon);
export default __webpack_public_path__ + "static/media/ExerciseLibInactiveIcon.db78839116b535bbdea64f4be7fb017c.svg";
export { ForwardRef as ReactComponent };